import { createSlice } from "@reduxjs/toolkit";
import { RESET_MANAGEMENT, SET_MANAGEMENT, SET_MANAGEMENT_MULTI } from 'services/redux/action-types'
import { managementConstants } from 'services/redux/management/constants'
import { createDateHelper, dateFormat } from 'utils/date-helper'

const initialState = {
	[ managementConstants.BUILDINGS ]: {},
	[ managementConstants.FLOORS ]: {},
	[ managementConstants.ROOMS ]: {},
	[ managementConstants.TABLES ]: {},
	
	[ managementConstants.TEAMS ]: {},
	
	[ managementConstants.SELECTED_TIMESLOTS ]: {},
	
	[ managementConstants.MANAGEMENT_SELECTED_START_DATE ]: null,
	[ managementConstants.MANAGEMENT_SELECTED_END_DATE ]: null,
	[ managementConstants.MANAGEMENT_CHART_DATE ]: [ null, null ]
};

const managementSlice = createSlice({
	name: 'management',
	initialState,
	reducers: {},
	extraReducers: ( builder ) => {
		builder
			.addCase( SET_MANAGEMENT, ( state, action ) => {
				state[ action.key ] = action.payload;
			})
			.addCase( SET_MANAGEMENT_MULTI, ( state, action ) => {
				Object.assign( state, action.payload );
			})
			.addCase( RESET_MANAGEMENT, () => {
				return initialState;
			});
	},
});

export default managementSlice.reducer;

/**
 *
 * @param state
 * @returns {*}
 */
export const getChartDateRange = ( state ) => {
	let dateRange = state.management[ managementConstants.MANAGEMENT_CHART_DATE ];
	
	// Date range not set? Create it!
	if( dateRange[ 0 ] === null ) {
		dateRange = createDateHelper( () => {
			return state;
		} ).defaultDateRange()
	}

	return dateRange
}

export const selectManagementSelectedStartDate = ( state ) => {
	return (state.management[ managementConstants.MANAGEMENT_SELECTED_START_DATE ] ?? createDateHelper( () => {
		return state;
	} ).date()).format( dateFormat.DATE );
}
export const selectManagementSelectedEndDate = ( state ) => {
	return (state.management[ managementConstants.MANAGEMENT_SELECTED_END_DATE ] ?? createDateHelper( () => {
		return state;
	} ).date()).format( dateFormat.DATE );
}
